import { NotesButtonProps } from "./types";
import { SquareToggleButton } from "@/components/atoms/squareToggleButton";
import { useIntl } from "react-intl";
import {
	Notepad24Regular,
	NotepadPerson24Regular,
} from "@fluentui/react-icons";
import { useState } from "react";
import { PopoverView } from "@/components/atoms/popover";
import { InteractionActionPopoverType } from "@/common/types/transfer";
import { InteractionNotesPopover } from "@/components/organisms/interactionNotes";
import { useNotes } from "@/hooks/notes";
import { Note, NoteType } from "@/components/organisms/history/types";
import {
	AgentState,
	useAgentStore,
} from "@/common/stores/persistingStores/agentPermissions";

export const NotesButton = (props: NotesButtonProps) => {
	const intl = useIntl();
	const [interactionNotes, setInteractionNotes] = useState<Note[]>([]);

	const agentState = useAgentStore((state: AgentState) => state);
	const interactionId = props.callId ? props.callId : props.interactionId;

	const { getNotes, onClickNotePopover } = useNotes(
		interactionId,
		setInteractionNotes,
		props.toggleInteractionPopoverOpening
	);

	const afterCreatingNote = (newNote: Note) => {
		setInteractionNotes([...interactionNotes, newNote]);
	};

	return (
		<PopoverView
			trigger={
				<SquareToggleButton
					icon={
						interactionNotes?.length > 0 ? (
							<NotepadPerson24Regular />
						) : (
							<Notepad24Regular />
						)
					}
					tooltip={intl.formatMessage({
						id:
							interactionNotes?.length > 0
								? "Interaction.Buttons.ViewNotes"
								: props.editMode
									? "Interaction.Buttons.AddNotes"
									: "Interaction.Buttons.NoNotes",
					})}
					disabled={!props.editMode && interactionNotes?.length === 0}
					onClick={() => getNotes(onClickNotePopover)}
					checked={
						props.interactionPopoverType ===
						InteractionActionPopoverType.InteractionNote
					}
				/>
			}
			content={
				<InteractionNotesPopover
					type={NoteType.InteractionNote}
					interactionNotes={interactionNotes}
					interactionId={props.interactionId}
					callId={props.callId}
					agentName={agentState.fullName}
					closePopover={() =>
						props.toggleInteractionPopoverOpening(
							InteractionActionPopoverType.InteractionNote
						)
					}
					afterCreatingNote={afterCreatingNote}
					editMode={props.editMode}
					isWrapUp={props.isWrapUp}
					canGenerateSummary={props.canGenerateSummary}
					enableCallSummary={props.enableCallSummary}
					autoInsertCallSummary={props.autoInsertCallSummary}
					enableTextSummary={props.enableTextSummary}
					autoInsertTextSummary={props.autoInsertTextSummary}
				/>
			}
			positioning={{ position: "below", align: "end", offset: { mainAxis: 8 } }}
			open={
				props.interactionPopoverType ===
				InteractionActionPopoverType.InteractionNote
			}
			onOpenChange={props.onOpenChange}
		/>
	);
};
